import Auth from "../../errorCodes/Auth"

/**
 * @todo: Handle all error codes in auth enum file
 */
export default function authErrorHandler(errorCode: string) {
  switch (errorCode) {
    case Auth.InvalidLoginDetails:
      return "errors.PBLOGInvalidLoginDetails"
    case Auth.InvalidPassword:
      return "errors.PBLOGPasswordCriteriaFailed"
    case Auth.UserDisabled:
    case Auth.BusinessDisabled:
      return "errors.PBLOGUserDisabled"
    default:
      return ""
  }
}
